import { Link, useLocation } from "@remix-run/react";
import { InsightsMixpanelEventsNames } from "~/components/insights/mixpanelEvents";
import useTracking from "~/hooks/useTracking";
import { useLanguage } from "~/hooks/useLanguage";

type CrucialInsightData = {
  to?: string;
  productId: string;
  id: string;
  shouldNotify?: boolean;
};

type Props = {
  closeDropdown: () => void;
  updateNotifications: (productId: string, insightId: string) => void;
  children: React.ReactNode;
  portfolioId?: number;
} & CrucialInsightData;

export type NotificationProps = {
  summary: React.ReactNode;
  notification: string;
  category?: string;
} & CrucialInsightData;

const DropdownNotification = ({
  to,
  productId,
  id,
  closeDropdown,
  updateNotifications,
  children,
  portfolioId,
}: Props) => {
  const location = useLocation();
  const tracking = useTracking();
  const { lang } = useLanguage();

  return (
    <Link
      dir={lang === "HEB" ? "rtl" : "ltr"}
      to={
        to || (productId && id ? `/insights/${id}/${productId}` : "/insights")
      }
      onClick={async (e) => {
        if (location.pathname === (to || (productId && id ? `` : "/insights")))
          e.preventDefault();
        tracking.track(
          InsightsMixpanelEventsNames.CLICKING_ON_A_NOTIFICATION_FROM_THE_BELL_DROP_DOWN,
          {
            extraProperties: {
              from: "main bell",
              insightId: id,
            },
          }
        );

        const body = JSON.stringify({
          id,
          productId,
          portfolioId,
        });

        await fetch(`/insights/notification`, {
          method: "POST",
          body,
        });

        updateNotifications(productId, id);
        closeDropdown();
      }}
    >
      {children}
    </Link>
  );
};
export default DropdownNotification;
